"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 411.56 236.43",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M141.88,343.42a27.27,27.27,0,1,0,27.26,27.27A27.3,27.3,0,0,0,141.88,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,141.88,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M205.13,343.42a27.27,27.27,0,1,0,27.26,27.27A27.19,27.19,0,0,0,205.13,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,205.13,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M268.38,343.42a27.27,27.27,0,1,0,27.26,27.27A27.3,27.3,0,0,0,268.38,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,268.38,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M331.63,343.42a27.27,27.27,0,1,0,27.26,27.27A27.3,27.3,0,0,0,331.63,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,331.63,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M394.88,343.42a27.32,27.32,0,1,0,19.55,8.3A27.3,27.3,0,0,0,394.88,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,394.88,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M458.13,343.42a27.27,27.27,0,1,0,27.26,27.27A27.3,27.3,0,0,0,458.13,343.42Zm0,40.78a13.52,13.52,0,1,1,13.51-13.51A13.53,13.53,0,0,1,458.13,384.2Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M491.64,336.86a47.42,47.42,0,0,0-32-13.75H140.39a47.59,47.59,0,0,0-1.06,95.1H460.67a47.57,47.57,0,0,0,31-81.35Zm-31,67.6H139.33a33.86,33.86,0,0,1,1.06-67.6H459.61a33.86,33.86,0,0,1,1.06,67.6Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M283.13,181.79h-123a6.87,6.87,0,0,0-6.87,6.87v123a6.88,6.88,0,0,0,6.87,6.88h123a6.88,6.88,0,0,0,6.87-6.88v-123A6.87,6.87,0,0,0,283.13,181.79Zm-46.69,13.75V215H206.82v-19.5Zm39.81,109.25H167V195.54h26.07v26.37a6.88,6.88,0,0,0,6.87,6.88h43.38a6.87,6.87,0,0,0,6.87-6.88V195.54h26.06Z",
      transform: "translate(-94.22 -181.79)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M439.88,181.79h-123a6.87,6.87,0,0,0-6.87,6.87v123a6.88,6.88,0,0,0,6.87,6.88h123a6.88,6.88,0,0,0,6.87-6.88v-123A6.87,6.87,0,0,0,439.88,181.79Zm-46.7,13.75V215H363.56v-19.5ZM433,304.79H323.75V195.54h26.06v26.37a6.87,6.87,0,0,0,6.87,6.88h43.38a6.88,6.88,0,0,0,6.87-6.88V195.54H433Z",
      transform: "translate(-94.22 -181.79)"
    })]
  });
};

exports.default = Icon;